module.exports = "<div class=\"container\">\n  <org-chart [nodes]=\"service.rootEntities\" (onClicked)=\"gotoDashboard($event)\"></org-chart>\n</div>"